import {Injectable} from '@angular/core';
import {AuthHttp} from './auth-http.service';
import {Observable} from 'rxjs/Observable';
import {BoardType, Country, FormalityScale, Language, ProductType, Region} from './core.types';

@Injectable()
export class StaticService {
    constructor(private http: AuthHttp) {
    }

    // TODO add observable data type like in getBoardType
    getAirportsBySuperRegion(superRegion) {
        return this.http.get('basic/airports/' + superRegion + '/name')
            .map(response => response.json())
    }

    getBoardTypes(): Observable<BoardType[]> {
        // without sorting
        return this.http.get('basic/static/boardTypes')
            .map(response => response.json().boardTypes);
    }

    getCountries(): Observable<Country[]> {
        return this.http.get('basic/static/countries/name')
            .map(response => response.json().countries);
    }

    getFormalityScales(): Observable<FormalityScale[]> {
        // without sorting
        return this.http.get('basic/static/formalityScales')
            .map(response => response.json().formalityScales);
    }

    // TODO add observable data type like in getBoardType
    getFromAirports() {
        return this.http.get('basic/static/fromAirports/name')
            .map(response => response.json().fromAirports);
    }

    // TODO use this for Language selection TOP menu
    getLanguages(): Observable<Language[]> {
        return this.http.get('basic/static/languages/name')
            .map(response => response.json().languages);
    }

    // /name should be added for sorted list
    getProductTypes(): Observable<ProductType[]> {
        return this.http.get('basic/static/productTypes')
            .map(response => response.json().productTypes);
    }

    // TODO replace it by getRegionsBySuperRegion and delete this function
    getRegions(): Observable<Region[]> {
        return this.http.get('basic/static/regions/name')
            .map(response => response.json().regions);
    }

    getRegionsBySuperRegions(superRegion): Observable<Region[]> {
        return this.http.get('basic/regions/' + superRegion + '/name')
            .map(response => response.json())
    }

    // TODO add observable data type like in getBoardType
    getRoomTypes() {
        return this.http.get('basic/static/roomTypes/short')
            .map(response => response.json().roomTypes);
    }

    // TODO add observable data type like in getBoardType
    getSuperRegions(): Observable<ProductType[]> {
        return this.http.get('basic/static/superRegions/name')
            .map(response => response.json().superRegions);
    }


}



// WEBPACK FOOTER //
// ./src/app/core/static.service.ts